/** @jsxImportSource theme-ui */

type Props = {
  fill?: string;
  stroke?: string;
};

const IconProjectCWG = ({ fill = "none", stroke = "white", ...props }: Props) => (
  <svg viewBox="0 0 467 456" fill={fill} {...props}>
    <path
      d="M78.225 84.655c0 48.906-12.722 93.928-38.165 135.065C1.896 281.427 279.562-17.609 320.07 9.778 360.575 37.164-9.576 293.702 9.731 339.073 29.037 384.444 303.182 74.93 320.069 126.215c11.258 34.19-69.357 100.854-241.844 199.995L459 70.366 156.791 358.433l233.83-162.581-243.734 251.559 300.326-289.398c-91.932 117.991-131.848 181.654-119.749 190.991 12.099 9.336 38.323-9.873 78.673-57.627"
      strokeWidth={16}
      strokeLinecap="round"
      strokeLinejoin="round"
      sx={{ stroke }}
    />
  </svg>
);

export default IconProjectCWG;
